import React from "react";

// Main App Component
const App = () => {
  const navItems = [
    { name: "Our Mission", href: "#mission" },
    { name: "Services", href: "#services" },
    { name: "Volunteer", href: "#volunteer" },
    { name: "Contact", href: "#contact" },
  ];

  const teamMembers = [
    {
      id: 1,
      title: "Managing Director",
      name: "Raj Shekhatr Khanna",
      role: "Client Relations & Strategy",
      icon: "💼",
    },
    {
      id: 2,
      title: "CTO",
      name: "Akhilesh Agarwal",
      role: "Technical Lead & Architecture",
      icon: "👨‍💻",
    },
    {
      id: 3,
      title: "Head of Operations",
      name: "Aman Seth",
      role: "Talent & Project Oversight",
      icon: "👥",
    },
  ];

  return (
    <div style={{ fontFamily: "Arial, sans-serif", lineHeight: 1.6 }}>
      {/* Header */}
      <header
        style={{
          backgroundColor: "#fff",
          padding: "16px 32px",
          borderBottom: "1px solid #ccc",
          position: "sticky",
          top: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <h1 style={{ margin: 0 }}>🌐 ARAsoftech</h1> */}
          <h1
            style={{
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <img
              src="\ARAsoftech logo.png"
              style={{ height: "1.5em", width: "auto" }}
            />
            ARAsoftech
          </h1>
          <nav style={{ display: "flex", gap: "16px" }}>
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                style={{ textDecoration: "none", color: "#333" }}
              >
                {item.name}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <main>
        {/* Hero Section */}
        <section
          style={{
            backgroundColor: "#3366cc",
            color: "#fff",
            textAlign: "center",
            padding: "60px 20px",
          }}
          id="hero"
        >
          <h2 style={{ fontSize: "36px" }}>
            Digitizing Communities,
            <br />
            <span style={{ color: "#00ffd0" }}>Empowering Local Growth.</span>
          </h2>
          <p style={{ maxWidth: "600px", margin: "20px auto" }}>
            Volunteer-driven development creating custom, high-quality web
            solutions for local businesses to thrive in the digital economy.
          </p>
          <a
            href="#contact"
            style={{
              display: "inline-block",
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#00ffd0",
              color: "#000",
              borderRadius: "6px",
              textDecoration: "none",
            }}
          >
            Partner with Us
          </a>
        </section>

        {/* Mission */}
        <section
          id="mission"
          style={{
            padding: "60px 20px",
            backgroundColor: "#fff",
            textAlign: "center",
          }}
        >
          <h3 style={{ color: "#009688" }}>Our Mission</h3>
          <h2>Bridging the Digital Divide</h2>
          <p style={{ maxWidth: "700px", margin: "0 auto" }}>
            Many small, local businesses are left behind in the digital age due
            to resource constraints. ARAsoftech exists to fill that gap. We
            leverage the passion and skills of emerging student talent to
            provide essential, custom-built online presences and operational
            tools, ensuring every local enterprise can compete and grow.
          </p>
        </section>

        {/* Services */}
        <section
          id="services"
          style={{ padding: "60px 20px", backgroundColor: "#f9f9f9" }}
        >
          <h2 style={{ textAlign: "center" }}>Tailored Digital Solutions</h2>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "20px",
              marginTop: "40px",
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                width: "300px",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <h3>🌍 Custom Landing Pages</h3>
              <p>
                Establish a powerful first impression. We build responsive, fast
                websites to showcase your business beautifully.
              </p>
            </div>
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                width: "300px",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              <h3>💼 Business Management Systems</h3>
              <p>
                Go beyond a static site with custom tools for billing,
                inventory, and appointments. Built with modern tech.
              </p>
            </div>
          </div>
        </section>

        {/* Volunteer */}
        <section
          id="volunteer"
          style={{
            padding: "60px 20px",
            backgroundColor: "#4b0082",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <h3 style={{ color: "#00ffd0" }}>Internship Program</h3>
          <h2>Build Your Portfolio, Make an Impact.</h2>
          <p style={{ maxWidth: "700px", margin: "20px auto" }}>
            We are seeking enthusiastic second and third-year students
            interested in React.js. Gain real experience, contribute to
            projects, and receive a certificate.
          </p>
          <a
            href="#contact"
            style={{
              display: "inline-block",
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#fff",
              color: "#4b0082",
              borderRadius: "6px",
              textDecoration: "none",
            }}
          >
            Apply to Volunteer Today
          </a>
        </section>

        {/* Team */}
        <section
          id="team"
          style={{ padding: "60px 20px", backgroundColor: "#fff" }}
        >
          <h2 style={{ textAlign: "center" }}>Our Founding Team</h2>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "20px",
              marginTop: "40px",
            }}
          >
            {teamMembers.map((member) => (
              <div
                key={member.id}
                style={{
                  textAlign: "center",
                  padding: "20px",
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  width: "200px",
                }}
              >
                <div style={{ fontSize: "32px", marginBottom: "10px" }}>
                  {member.icon}
                </div>
                <h3>{member.title}</h3>
                <h4>{member.name}</h4>
                <p style={{ fontSize: "14px", color: "#555" }}>{member.role}</p>
                <p style={{ fontSize: "12px", color: "#888" }}>
                  Co-founder, ARAsoftech
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Contact */}
        <section
          id="contact"
          style={{
            padding: "60px 20px",
            backgroundColor: "#f0f0f0",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontSize: "28px", marginBottom: "16px" }}>
            Get in Touch
          </h2>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "24px",
              maxWidth: "600px",
              marginInline: "auto",
            }}
          >
            We're always open to collaborations, partnerships, and passionate
            volunteers! The best way to reach us is through our official
            LinkedIn page.
          </p>
          <a
            href="https://www.linkedin.com/company/arasoftech"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "12px 24px",
              backgroundColor: "#0077b5", // LinkedIn blue
              color: "#fff",
              textDecoration: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#005582")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#0077b5")}
          >
            🔗 Message Us on LinkedIn
          </a>
        </section>
      </main>

      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#333",
          color: "#ccc",
          fontSize: "14px",
        }}
      >
        &copy; {new Date().getFullYear()} ARAsoftech. All rights reserved. |
        Volunteer-Driven Community Initiative
      </footer>
    </div>
  );
};

export default App;
